import React, { useEffect,useState } from "react";
import { useSelector } from "react-redux";
import { PieChart, Pie, Tooltip, ResponsiveContainer, Text, Legend, LabelList, BarChart, Bar, XAxis, Cell, CartesianGrid, YAxis, Label } from "recharts";
import { Grid, Box } from "@mui/material";
import myStatsReducer from "../../Reducer/myStatsReducer";
import Paper from '@mui/material/Paper';
import { Card } from "antd";



export default function Graph(props) {
  const myStatState = useSelector((state) => state.myStatsData);
  const userState = useSelector((state) => state.user);
  const [res,setRes] = useState([]);
  const [apac,setApac] = useState([])  
  // let renderLabel = function (entry) {
  //   return entry.name;
  // }
  const GET_COLORS = [
    '#7CB5EC',
    '#A0A0A0',  // Replaced dark gray with a softer gray
    'rgb(144, 237, 125)', 
    '#f45b5b',  
    '#91e8e1', 
    '#8085e9',  
    '#e4d354',  
    '#f7a35c',  
    '#2b908f',  
    '#90ee7e',  
  ];

  // const RatedData = [];
  // const nonRated = Object.entries(myStatState.ratingsByGroup !== null && myStatState.ratingsByGroup).map(([name, value]) => ({ name, value }));
  // const obj1 = { name: 'Rated', value: sum }
  // const obj2 = { name: 'Non Rated', value: (nonRated.length !== 0 &&nonRated[0].value) }
  // RatedData.push(obj1);
  // RatedData.push(obj2);
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <div>
            {payload.map((pld) => (
              <div style={{ display: "inline-block", padding: 7,backgroundColor:"#f3f3f3",color:"black",fontSize:"12px"}}>
                <div style={{ color: pld.fill }}>{pld.name}:&nbsp;<b>{pld.value.toLocaleString()}</b></div>
              </div>
            ))}
          </div>
        </div>
      );
    }
  
    return null;
  };
  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
  
    return (
      <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };
  
  useEffect(()=>{
    let newArray = myStatState.domainByExpert.map((data) => {
      return { name: data.domainName, value: data.answerCount, fill: "rgb(124, 181, 236)" }
    })
    const getAllValues = Object.values(myStatState.ratingsByGroup);
    const ratingStarsColors = ['rgb(220,132,6)', 'rgb(255,150,0)', 'rgb(255,173,0)', 'rgb(255,197,0)', 'rgb(255,220,0)'];
    const ratingStarsData = Object.entries(myStatState.ratingsByGroup !== null && myStatState.ratingsByGroup).map(([name, value]) => ({ name: name + " " + "star", value: value }))
    ratingStarsData.shift();
    ratingStarsData.map((data, ind) => {
      return { name: data.name, value: data.value, fill: ratingStarsColors[ind] }
    })
    const sum = getAllValues.reduce((a, b) => {
      return a + b;
    }, 0);
  },[])

  const headingColor = {
		color:'rgb(42, 54, 74)'
	}


  return (<>
    <Grid item xs={12} sm={12} lg={6} xl={6} md={12} spacing={1}>
        <Card title='View Count Per User' style={{textAlign:'center'}} styles={{header:headingColor}}>
        <Box sx={{ display: "flex", width: "100%" }}>
            <ResponsiveContainer width="100%" height={300}>
        {/* <div className={Styles.chartWrapper}> */}
          <PieChart>
            <Pie
              dataKey="value"
              startAngle={180}
              endAngle={0}
              data={myStatState.getDataForViewCountPerUser}
              fill="rgb(124, 181, 236)"
              label={(value)=>value?.value.toLocaleString()}
              cursor="default"
              cy="90%"
              cx="50%"
              paddingAngle={5}
              isAnimationActive={false}
              outerRadius="120%"
              innerRadius="60%"
            >
              {GET_COLORS.map((entry, index) => (
                <Cell style={{ outline: 'none' }} key={`cell-${index}`} fill={GET_COLORS[index % GET_COLORS.length]} />
              ))}
              </Pie>
            <Tooltip content={<CustomTooltip />}  itemStyle={{ fontFamily: "inherit", fontSize: "12px" }}>
            </Tooltip>
            <Legend iconSize={10} fontSize={10} iconType="circle" wrapperStyle={{fontSize:'12px'}} verticalAlign="bottom" height={34} />
          </PieChart>
        {/* </div> */}
        </ResponsiveContainer>
        </Box>
        </Card>
        </Grid>
              <Grid item xs={12} xl={6} lg={6} >
        {/* <div className={Styles.chartWrapper}> */}
        <Card title='View Count Per Geo' style={{textAlign:'center'}} styles={{header:headingColor}}>
        <Box sx={{ display: "flex", width: "100%",flexGrow:1 }}>
            <ResponsiveContainer width="100%" height={300}>
              {/* {console.log(myStatState.getDataForViewCountPerGeo,'check 123')} */}
          <PieChart>
            <Pie
              dataKey="value"
              startAngle={180}
              endAngle={0}
              data={myStatState.getDataForViewCountPerGeo}
              outerRadius="120%"
              innerRadius="60%"
              cy="90%"
              cx="50%"
              fill="rgb(124, 181, 236)"
              paddingAngle={3}
              cursor="default"
              label={(value)=>value?.value.toLocaleString()}
              isAnimationActive={false}
            >
                {/* <Label position="center"  dy={9} offset={0} style={{marginTop:"25px",fontWeight:"bold"}}>
                View count per Geo
                </Label> */}
                {GET_COLORS.map((entry, index) => (
                <Cell style={{ outline: 'none' }} key={`cell-${index}`} fill={GET_COLORS[index % GET_COLORS.length]} />
              ))}
                </Pie>
            <Tooltip content={<CustomTooltip />} itemStyle={{ fontFamily: "inherit", fontSize: "12px" }} />
            <Legend iconSize={10} fontSize={12} iconType="circle"wrapperStyle={{fontSize:'12px',cursor:'default'}} verticalAlign="bottom" height={34} />
          </PieChart>
          </ResponsiveContainer>
          </Box>
        </Card>
      </Grid>
  </>)
}
